import React from 'react'

const Shimmer = () => {
    return (
        <div className="shimmerWrapper">
            <div className="shimmer"></div>
        </div>
    )
}

export default Shimmer
